// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"8179a1fc","453":"5e80db44","548":"56bdbfea"}[chunkId] + ".chunk.js";
};